export enum ReviewStatus {
  Unknown = 0,
  Received = 1,
  InProgress = 2,
  ManagerReviewRequired = 3,
  Completed = 4
}
